<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.delete') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="block_delete">

                <loading slot="waiting"/>

                <b-alert variant="danger" show> {{ $t('simple.delete_confirm') }}</b-alert>

            </v-wait>

          </div>

          <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <b-button @click="block_remove" variant="primary">{{ $t('simple.delete') }}</b-button>
            
          </div>

        </div>
      </div>
    </div>
</template>
<script>

    export default {

        mounted: function () {
            console.log('Block List Remove Modal mounted');
        },

        destroyed() {
            console.log('Block List Remove Modal destroyed.');
        },

        data: function() {
             return  {}
        },

        methods: {

            block_remove: async function(){

                // Loading start
                this.$wait.start('block_delete');

                // Block Remove
                await axios.put('/api/v1/twitter/blocks/' + this.id, { user_id: this.user_id})
                .then((response) => {

                    // Show success
                    Vue.toasted.success(this.$t('simple.deleted_confirmed'));

                    // Close modal
                    this.$close(true);
                    //console.log(response);

                    // Loading stop
                    this.$wait.end('block_delete');

                })
                .catch((error) => {
                    // Show error
                    Vue.toasted.error(this.$t('simple.error_info'));

                    // Log to console
                    console.log(error);

                    // Close modal
                    this.$close(true);

                    // Loading stop
                    this.$wait.end('block_delete');
                });

            },
        },
    }
</script>